import React, {useCallback, useState} from 'react';
import {ClientManagementLayout} from "../layouts/ClientManagementLayout";
import {Pane} from "evergreen-ui";
import {ProviderEventList} from "./ProviderEventList";
import {initState, providerEventListReducer} from "./providerEventListReducer";
import {ProviderEventListMarkReadModal} from "./ProviderEventListMarkReadModal";
import {useMarkProviderEventsAsRead} from "./useMarkProviderEventsAsRead";
import {useProviderEventUnreadDispatch} from "./ProviderEventUnreadCount";
import {useCurrentUser} from "../../security";
import {TreatmentHoldEndConfirmationModal} from "./TreatmentHoldEndConfirmationModal";
import {ProviderEvent} from "./domain";


export const ProviderEventListPage = () => {
    const currentUser = useCurrentUser();
    const [confirmationEvent, setConfirmationEvent] = useState<ProviderEvent | null>(null);
    const [{
        pagination,
        pageSize,
        sortBy,
        filter,
        selected,
        refetchFunc
    }, dispatch] = React.useReducer(providerEventListReducer, initState())
    const dispatchProviderEventUnread = useProviderEventUnreadDispatch();
    const {
        execute: markEventAsReadFunc
    } = useMarkProviderEventsAsRead(() => {
        if (refetchFunc) {
            refetchFunc();
        }

        dispatch({type: "SET_SELECTED", selected: null});
        dispatchProviderEventUnread({type: 'DECREASE', num: 1});
    });

    const handleConfirmationSuccess = useCallback(() => {
        if (refetchFunc) {
            refetchFunc();
        }
    }, [refetchFunc]);

    return (<ClientManagementLayout customSelection={"Notification"}>
        <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
            <ProviderEventList
                currentUser={currentUser}
                markEventAsReadFunc={markEventAsReadFunc}
                selected={selected}
                pagination={pagination}
                sortBy={sortBy}
                filterValue={filter}
                dispatch={dispatch}
                pageSize={pageSize}
                onConfirmEndDateClick={setConfirmationEvent}
            />

            <TreatmentHoldEndConfirmationModal
                providerEvent={confirmationEvent}
                onClose={() => setConfirmationEvent(null)}
                onSuccess={handleConfirmationSuccess}
            />

            <ProviderEventListMarkReadModal selected={selected}
                                            currentUser={currentUser}
                                            dispatch={dispatch}
                                            refetchFunc={refetchFunc}
                                            dispatchProviderEventUnread={dispatchProviderEventUnread}/>
        </Pane>
    </ClientManagementLayout>);
}
